import React from 'react';
import { LongSize } from '../product_detail/components/size.enum';
import { Dropdown, DropdownProps } from './Dropdown';

export const SizeDropdown: React.FC<DropdownProps<LongSize>> = (props) => <Dropdown {...props} />;

export default SizeDropdown;
